import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { ForestryBasePopulationJobResultDto } from '../dtos/forestry-base/models';

@Injectable({
  providedIn: 'root',
})
export class ForestryBaseJobOrchestratorService {
  private restService = inject(RestService);
  apiName = 'Orchestrator';
  

  runPopulationJob = (cancellationToken: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ForestryBasePopulationJobResultDto>({
      method: 'POST',
      url: '/api/orchestrator/forestry-base-jobs/run-population',
    },
    { apiName: this.apiName,...config });
}